<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true" [autoLayout]="true" dataKey="id"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
    styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div *ngIf="showTitle" class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title">
            {{ 'tableManagement.financing.financingsManagement' | translate }}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr>

            <!-- SELECT -->
            <th class="checkbox-column">
                <div class="d-flex justify-content-center">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </div>
            </th>
                        <!-- CONTRACT -->
                        <th pSortableColumn="contract">
                            <div class="d-flex align-items-center h-100">
                                <!-- COLUMN TITLE -->
                                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                                    {{ 'tableManagement.financing.contract' | translate }}
                                </div>
            
                                <!-- COLUMN SORT && FILTER ICONS -->
                                <div class="d-flex align-items-center h-100">
                                    <p-sortIcon field="contract"></p-sortIcon>
                                    <p-columnFilter field="contract" type="text" matchMode="contains"
                                        placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                                        [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                                </div>
                            </div>
                        </th>
                        <!-- PROVIDER -->
                        <th pSortableColumn="provider.name">
                            <div class="d-flex align-items-center h-100">
            
                                <!-- COLUMN TITLE -->
                                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                                    {{ 'tableManagement.providers.provider' | translate }}
                                </div>
            
                                <!-- COLUMN SORT && FILTER ICONS -->
                                <div class="d-flex align-items-center h-100">
                                    <p-sortIcon field="provider.name"></p-sortIcon>
                                    <p-columnFilter field="provider" type="text" matchMode="contains"
                                        placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                                        [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                                </div>
            
                            </div>
                        </th>

                        <!-- FINANCING TYPE -->
			<th pSortableColumn="financingType.name">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.financing.financingType' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<div class="d-flex align-items-center h-100">
							<p-sortIcon field="financingType.name"></p-sortIcon>
							<p-columnFilter [showApplyButton]="true" field="financingType" matchMode="in" display="menu"
								[showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body"
								[hideOnClear]="true">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-multiSelect [ngModel]="value" (onChange)="filter($event.value);" [filter]="true"
										[options]="financingTypeList" placeholder="{{ 'general.filters.any' | translate }}"
										[virtualScroll]="true" itemSize="30" optionLabel="name" optionValue="id"
										[showToggleAll]="false" [panelStyle]="{'min-width': '350px'}">
										<ng-template let-option pTemplate="item">
											<div>
												<span class="ml-1">{{option.name}}</span>
											</div>
										</ng-template>
									</p-multiSelect>
								</ng-template>
							</p-columnFilter>
						</div>
					</div>
				</div>
			</th>

                        <!-- RENTING TYPE -->
                        <th pSortableColumn="rentingType.name">
                            <div class="d-flex align-items-center h-100">
            
                                <!-- COLUMN TITLE -->
                                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                                    {{ 'tableManagement.rentingTypes.rentingType' | translate }}
                                </div>
            
                                <!-- COLUMN SORT && FILTER ICONS -->
                                <div class="d-flex align-items-center h-100">
                                    <p-sortIcon field="rentingType.name"></p-sortIcon>
                                    <p-columnFilter field="rentingType" type="text" matchMode="contains"
                                        placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                                        [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                                </div>
            
                            </div>
                        </th>




            <!-- START DATE -->
            <th pSortableColumn="startDate">
                <div class="d-flex align-items-center h-100">

                    <!-- COLUMN TITLE -->
                    <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.financing.start' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="startDate"></p-sortIcon>

                    </div>
                </div>
            </th>

            <!-- END DATE -->
            <th pSortableColumn="endDate">
                <div class="d-flex align-items-center h-100">

                    <!-- COLUMN TITLE -->
                    <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.financing.end' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="endDate"></p-sortIcon>

                    </div>

                </div>
            </th>

            <!-- MONTHLY FEE -->
            <th *ngIf="isCostGranted" pSortableColumn="monthlyFee">
                <div class="d-flex align-items-center h-100">

                    <!-- COLUMN TITLE -->
                    <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.financing.monthlyFee' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="monthlyFee"></p-sortIcon>
                        <p-columnFilter field="monthlyFee" type="numeric" matchMode="contains"
                            placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- CONTRACT KM -->
            <th pSortableColumn="contractKm">
                <div class="d-flex align-items-center h-100">

                    <!-- COLUMN TITLE -->
                    <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.financing.contractKms' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="contractKm"></p-sortIcon>
                        <p-columnFilter field="ContractKm" type="numeric" matchMode="contains"
                            placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>


            <!-- CANCELLATION DATE -->
            <th pSortableColumn="cancellationDate">
                <div class="d-flex align-items-center h-100">

                    <!-- COLUMN TITLE -->
                    <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.financing.cancelationDate' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="endDate"></p-sortIcon>

                    </div>

                </div>
            </th>

            <!-- DELETE -->
			<th class="button-column"></th>

        </tr>
    </ng-template>
    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-entity>
        <tr class="p-selectable-row custom-rows" (dblclick)="editDialog(entity)" [ngClass]="{
            'table-red-row' :shouldBeRed(entity)}">

            <!-- SELECT -->
            <td>
                <div class="d-flex justify-content-center">
                    <p-tableCheckbox [value]="entity"></p-tableCheckbox>
                </div>
            </td>

            <!-- CONTRACT -->
            <td>
                {{ entity.contract }}
            </td>
            <!-- PROVIDER -->
            <td>
                {{entity.provider?.name}}
            </td>

            <td>
                {{entity.financingType?.name}}
            </td>
            <!-- RENTING TYPE -->
            <td>
                {{entity.rentingType?.name}}
            </td>
       
            <!-- START DATE -->
            <td>
                {{ entity.startDate | date: 'dd/MM/yyyy' }}
            </td>

            <!-- END DATE -->
            <td>
                {{ entity.endDate | date: 'dd/MM/yyyy' }}
            </td>

            <td *ngIf="isCostGranted">
                {{ entity.monthlyFee | number: '1.2-2' }}
            </td>

            <td>
                {{ entity.contractKm | number }}
            </td>
            <!-- CANCELATION DATE -->
            <td>
                {{ entity.cancellationDate | date: 'dd/MM/yyyy' }}
            </td>

            <!-- DELETE -->
			<td>
				<div *ngIf="isDisabledGranted">
					<button  type="button" class="btn custom-table-remove-button" (click)="onDeleteFinancing(entity)">
						<svg-icon
							src="assets/icons/trash.svg"
							class="d-flex flex-wrap custom-table-remove-button-icon"
							[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
						></svg-icon>
					</button>
				</div>

			</td>


        </tr>

    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numColumns" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

    <!-- #region TABLE FOOTER -->
    <ng-template pTemplate="footer">
        <tr>
            <td [attr.colspan]="numColumns" class="p-0">
                <div class="d-flex flex-row align-items-center p-3 gap-3">

                    <!-- ADD FINE BUTTON -->
                    <app-table-add-button *ngIf="isCreateGranted"
                        [text]=" 'tableManagement.financing.financings' | translate"
                        (btnClick)="create()"></app-table-add-button>

                    <!-- CHANGE STATUS BUTTON -->
                    <app-table-change-status-button (btnClick)="changeStatus()"
                        [isDisabled]=" selectedEntities.length === 0 || !isDisabledGranted"></app-table-change-status-button>

                    <!-- ADD DUPLICATE BUTTON -->
                    <app-table-duplicate-button [text]=" 'tableManagement.financing.financings' | translate"
                        [isDisabled]="selectedEntities.length !== 1 || !isCreateGranted"
                        (btnClick)="duplicate(selectedEntities)"></app-table-duplicate-button>


                    <app-table-excel-button class="buttonTableExcel"
                        (btnClick)="exportExcel()"></app-table-excel-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE FOOTER -->
</p-table>

<!-- FINE FORM -->
<app-financing-form [vehicle]="vehicle" (return)="refreshList($event,false)"></app-financing-form>
<p-confirmDialog
#saveEventDialog2
[header]="'confirm.critic' | translate"
[message]="'control-panel.delete-dialog.message' | translate"
class="custom-dialog"
icon="pi pi-exclamation-triangle"
key="financing-list"
>
<ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog2.reject()" class="custom-button">
        {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog2.accept()" class="custom-button">
        {{ 'general.yes' | translate }}
    </button>
</ng-template>
</p-confirmDialog>

<div *ngIf="showStatusDialog">

    <app-change-status-shared [items]=" 'tableManagement.financing.financings' | translate " [display]="true"
        [service]=financingService [entitiesList]=selectedEntities (return)="refreshList($event)"
        (close)="closeStatusDialog($event)"></app-change-status-shared>

</div>